import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import DocumentList from "./DocumentList";
import Upload from "./Upload";
import Workinprogrees from "../../../../components/Workinprogrees";
import DocumentNewList from "./DocumentNewList";
import ProjectSubHeader from "../../components/ProjectSubHeader";

const tabsKey = {
  list: 1,
  upload: 2,
};

const Documents = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("tab") || "list";
  const defaultActiveKey = tabsKey[selectedTab];
  const [activeTab, setActiveTab] = useState(
    parseInt(defaultActiveKey) === 1 ? "List" : "Upload"
  );

  return (
    <>
      <div className="cms-page">
        <Workinprogrees />
        <div className="page-content-block">
          <div className="full-content-block">
            <ProjectSubHeader title={"Documents"} />
            <div className="content-details">
              <div className="table-top-btn">
                <ul
                  className="nav nav-tabs"
                  onClick={(event) => {
                    setActiveTab(event?.target?.innerText);
                  }}
                >
                  <li className={activeTab === "List" ? "active" : ""}>
                    <Link key={1}>List</Link>
                  </li>
                  <li className={activeTab === "Upload" ? "active" : ""}>
                    <Link key={2}>Upload</Link>
                  </li>
                </ul>
              </div>
              <div className="custom-table tab-table">
                {activeTab === "List" && <DocumentNewList />}
                {activeTab === "Upload" && <Upload />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Documents;
